import { GraphQLClient, RequestOptions } from "graphql-request";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
};

export type ActivityLinkResult = {
  __typename?: "ActivityLinkResult";
  canonical_activity_id?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  link_status: Scalars["String"]["output"];
  link_suggestion_score?: Maybe<Scalars["Float"]["output"]>;
};

export type ActivityReaction = {
  __typename?: "ActivityReaction";
  activity_id: Scalars["Int"]["output"];
  created_at: Scalars["DateTime"]["output"];
  emoji: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  reactor: Scalars["String"]["output"];
  user_id: Scalars["Int"]["output"];
};

export type ActivityStats = {
  __typename?: "ActivityStats";
  activity: Scalars["String"]["output"];
  count: Scalars["Int"]["output"];
  orgasm_correlation: Scalars["Float"]["output"];
};

export type ActivityUsageStat = {
  __typename?: "ActivityUsageStat";
  activity_label: Scalars["String"]["output"];
  activity_name: Scalars["String"]["output"];
  count: Scalars["Int"]["output"];
  distinct_users: Scalars["Int"]["output"];
};

export type AnalyticsSummary = {
  __typename?: "AnalyticsSummary";
  daily_usage?: Maybe<Array<Maybe<DailyUsage>>>;
  feature_stats?: Maybe<Array<Maybe<FeatureUsageStats>>>;
  total_users: Scalars["Int"]["output"];
};

export type CoupleEmails = {
  __typename?: "CoupleEmails";
  husbandEmail?: Maybe<Scalars["String"]["output"]>;
  primaryEmail?: Maybe<Scalars["String"]["output"]>;
  wifeEmail?: Maybe<Scalars["String"]["output"]>;
};

export enum CyclePhase {
  Fertile = "FERTILE",
  Luteal = "LUTEAL",
  Other = "OTHER",
  Ovulation = "OVULATION",
  Period = "PERIOD",
}

export type CyclePrediction = {
  __typename?: "CyclePrediction";
  average_cycle_length?: Maybe<Scalars["Float"]["output"]>;
  average_period_length?: Maybe<Scalars["Float"]["output"]>;
  days?: Maybe<Array<Maybe<DayWithPhase>>>;
  fertile_window_end?: Maybe<Scalars["String"]["output"]>;
  fertile_window_start?: Maybe<Scalars["String"]["output"]>;
  next_ovulation?: Maybe<Scalars["String"]["output"]>;
  next_period_end?: Maybe<Scalars["String"]["output"]>;
  next_period_start?: Maybe<Scalars["String"]["output"]>;
};

export type DailyUsage = {
  __typename?: "DailyUsage";
  date: Scalars["String"]["output"];
  feature_name: Scalars["String"]["output"];
  total_uses: Scalars["Int"]["output"];
  unique_users: Scalars["Int"]["output"];
};

export type DayWithPhase = {
  __typename?: "DayWithPhase";
  date: Scalars["String"]["output"];
  is_period: Scalars["Boolean"]["output"];
  is_predicted: Scalars["Boolean"]["output"];
  phase: CyclePhase;
};

export type FeatureUsageStats = {
  __typename?: "FeatureUsageStats";
  all_time: Scalars["Int"]["output"];
  feature_name: Scalars["String"]["output"];
  last_month: Scalars["Int"]["output"];
  last_quarter: Scalars["Int"]["output"];
  last_week: Scalars["Int"]["output"];
  last_year: Scalars["Int"]["output"];
  yesterday: Scalars["Int"]["output"];
};

export type InitiatorCounts = {
  __typename?: "InitiatorCounts";
  husband: Scalars["Int"]["output"];
  mutual: Scalars["Int"]["output"];
  wife: Scalars["Int"]["output"];
};

export type IntimacyActivity = {
  __typename?: "IntimacyActivity";
  category?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_shared: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  sort_order: Scalars["Int"]["output"];
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type IntimacyActivityAdmin = {
  __typename?: "IntimacyActivityAdmin";
  canonical_activity?: Maybe<IntimacyActivityAdmin>;
  canonical_activity_id?: Maybe<Scalars["Int"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_shared: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  link_reviewed_at?: Maybe<Scalars["String"]["output"]>;
  link_reviewed_by?: Maybe<Scalars["Int"]["output"]>;
  link_status?: Maybe<Scalars["String"]["output"]>;
  link_suggestion_score?: Maybe<Scalars["Float"]["output"]>;
  name: Scalars["String"]["output"];
  sort_order: Scalars["Int"]["output"];
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type IntimacyActivityMutation = {
  __typename?: "IntimacyActivityMutation";
  canonical_activity_id?: Maybe<Scalars["Int"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  is_shared?: Maybe<Scalars["Boolean"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  link_status?: Maybe<Scalars["String"]["output"]>;
  link_suggestion_score?: Maybe<Scalars["Float"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  sort_order?: Maybe<Scalars["Int"]["output"]>;
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type IntimacySession = {
  __typename?: "IntimacySession";
  activities_husband?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  activities_shared?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  activities_wife?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  created_at?: Maybe<Scalars["String"]["output"]>;
  date?: Maybe<Scalars["String"]["output"]>;
  duration_minutes?: Maybe<Scalars["Int"]["output"]>;
  husband_orgasm_count?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initiator?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  substances?: Maybe<Array<Maybe<Substance>>>;
  time?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
  user_id?: Maybe<Scalars["Int"]["output"]>;
  wife_orgasm_count?: Maybe<Scalars["Int"]["output"]>;
};

export type IntimacyStats = {
  __typename?: "IntimacyStats";
  activity_counts: Array<ActivityStats>;
  activity_counts_husband: Array<ActivityStats>;
  activity_counts_wife: Array<ActivityStats>;
  activity_diversity: Scalars["Int"]["output"];
  avg_days_between_sessions: Scalars["Float"]["output"];
  avg_duration_minutes: Scalars["Float"]["output"];
  avg_husband_orgasms_per_session: Scalars["Float"]["output"];
  avg_sessions_per_week: Scalars["Float"]["output"];
  avg_wife_orgasms_per_session: Scalars["Float"]["output"];
  current_streak: Scalars["Int"]["output"];
  cycle_prediction?: Maybe<CyclePrediction>;
  days_since_husband_initiated?: Maybe<Scalars["Int"]["output"]>;
  days_since_husband_orgasm?: Maybe<Scalars["Int"]["output"]>;
  days_since_last_intimacy?: Maybe<Scalars["Int"]["output"]>;
  days_since_wife_initiated?: Maybe<Scalars["Int"]["output"]>;
  days_since_wife_orgasm?: Maybe<Scalars["Int"]["output"]>;
  initiator_counts: InitiatorCounts;
  longest_gap_days: Scalars["Int"]["output"];
  median_duration_minutes: Scalars["Float"]["output"];
  most_common_day_of_week?: Maybe<Scalars["String"]["output"]>;
  mutual_orgasm_rate: Scalars["Float"]["output"];
  new_activities_this_month: Array<Scalars["String"]["output"]>;
  orgasm_gap: Scalars["Float"]["output"];
  orgasm_ratio_husband: Scalars["Int"]["output"];
  orgasm_ratio_husband_recent: Scalars["Int"]["output"];
  orgasm_ratio_wife: Scalars["Int"]["output"];
  orgasm_ratio_wife_recent: Scalars["Int"]["output"];
  sessions_this_week: Scalars["Int"]["output"];
  sessions_with_zero_orgasms: Scalars["Int"]["output"];
  substance_stats: SubstanceStats;
  time_between_sessions_trend?: Maybe<Scalars["String"]["output"]>;
  total_husband_orgasms: Scalars["Int"]["output"];
  total_sessions: Scalars["Int"]["output"];
  total_wife_orgasms: Scalars["Int"]["output"];
};

export type MissedPrediction = {
  __typename?: "MissedPrediction";
  date: Scalars["String"]["output"];
  days_ago: Scalars["Int"]["output"];
  is_continuation: Scalars["Boolean"]["output"];
};

export type PartnerActivity = {
  __typename?: "PartnerActivity";
  activity_type: Scalars["String"]["output"];
  actor: Scalars["String"]["output"];
  created_at: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  is_read: Scalars["Boolean"]["output"];
  link?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  requires_response: Scalars["Boolean"]["output"];
  responded_at?: Maybe<Scalars["DateTime"]["output"]>;
  response_note?: Maybe<Scalars["String"]["output"]>;
  response_status?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  user_id: Scalars["Int"]["output"];
};

export type PeriodDay = {
  __typename?: "PeriodDay";
  date: Scalars["String"]["output"];
  explicit_mark: Scalars["Boolean"]["output"];
  id: Scalars["Int"]["output"];
  is_period: Scalars["Boolean"]["output"];
  user_id: Scalars["Int"]["output"];
};

export type PushLog = {
  __typename?: "PushLog";
  actor?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["DateTime"]["output"]>;
  endpoint?: Maybe<Scalars["String"]["output"]>;
  event_type?: Maybe<Scalars["String"]["output"]>;
  excluded_actor?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type PushSubscription = {
  __typename?: "PushSubscription";
  auth: Scalars["String"]["output"];
  created_at: Scalars["DateTime"]["output"];
  endpoint: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  p256dh: Scalars["String"]["output"];
  updated_at: Scalars["DateTime"]["output"];
  user_agent?: Maybe<Scalars["String"]["output"]>;
  user_id: Scalars["Int"]["output"];
};

export type Response = {
  __typename?: "Response";
  affectedRows?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RootMutation = {
  __typename?: "RootMutation";
  addCustomIntimacyActivity?: Maybe<UserPreferences>;
  addReaction: ActivityReaction;
  adventCalendarTestSend?: Maybe<Scalars["Boolean"]["output"]>;
  approveActivityLink: ActivityLinkResult;
  cancelScheduledSession: ScheduledIntimacySession;
  createActivity: PartnerActivity;
  createConversationStarterCard?: Maybe<Conversation_Starter_Card>;
  createIntimacyActivity: IntimacyActivityMutation;
  createScheduledSession: ScheduledIntimacySession;
  createUser?: Maybe<Response>;
  deleteConversationStarterCard?: Maybe<Response>;
  deleteIntimacyActivity: Scalars["Boolean"]["output"];
  deleteIntimacySession?: Maybe<Scalars["Boolean"]["output"]>;
  deleteScheduledSession: Scalars["Boolean"]["output"];
  linkActivityToCanonical: ActivityLinkResult;
  logIntimacySession?: Maybe<IntimacySession>;
  logPeriodDay: PeriodDay;
  markActivitiesRead?: Maybe<Scalars["Boolean"]["output"]>;
  markSessionOutcome: ScheduledIntimacySession;
  notifyEmailChange?: Maybe<Scalars["Boolean"]["output"]>;
  refreshPurchases?: Maybe<Scalars["JSON"]["output"]>;
  rejectActivityLink: ActivityLinkResult;
  removeCustomIntimacyActivity?: Maybe<UserPreferences>;
  removeReaction?: Maybe<Scalars["Boolean"]["output"]>;
  rescanActivityLinkSuggestions: Scalars["Int"]["output"];
  respondToActivity: PartnerActivity;
  respondToConversationStarter?: Maybe<Response>;
  respondToMissedPrediction: Scalars["Boolean"]["output"];
  respondToScheduledSession: ScheduledIntimacySession;
  scheduleReminder?: Maybe<ScheduleReminderResult>;
  setConversationStarterCategoryPrefs?: Maybe<Response>;
  setPushExcludedActor?: Maybe<Scalars["Int"]["output"]>;
  submitActivityRequest?: Maybe<Scalars["Boolean"]["output"]>;
  submitBugReport: SubmitBugReportResult;
  submitIdea: SubmitIdeaResult;
  subscribePush?: Maybe<PushSubscription>;
  /** Send a test email */
  testEmail?: Maybe<Scalars["String"]["output"]>;
  /** Test intimacy suggestion service for a specific user */
  testIntimacySuggestion?: Maybe<Scalars["String"]["output"]>;
  /** Create a test partner activity */
  testPartnerActivity?: Maybe<Scalars["String"]["output"]>;
  /** Send a test push notification */
  testPushNotification?: Maybe<Scalars["String"]["output"]>;
  /** Send a test session reminder notification with personalized OSL suggestions */
  testSessionReminder?: Maybe<Scalars["String"]["output"]>;
  trackFeatureUsage?: Maybe<Scalars["Boolean"]["output"]>;
  unlinkActivity: ActivityLinkResult;
  unsubscribePush?: Maybe<Scalars["Boolean"]["output"]>;
  updateCommunicationPreferences: UserPreferences;
  updateConversationStarterCard?: Maybe<Conversation_Starter_Card>;
  updateIntimacyActivity: IntimacyActivityMutation;
  updateIntimacyFrequencyPreferences: UserPreferences;
  updateSubstanceTrackingPreference: UserPreferences;
  updateUserSettings?: Maybe<Response>;
  updateUserSexplorationListCurrentSession?: Maybe<Response>;
  updateUserTimezone?: Maybe<Response>;
};

export type RootMutationAddCustomIntimacyActivityArgs = {
  activity: Scalars["String"]["input"];
};

export type RootMutationAddReactionArgs = {
  activity_id: Scalars["Int"]["input"];
  emoji: Scalars["String"]["input"];
  reactor: Scalars["String"]["input"];
};

export type RootMutationAdventCalendarTestSendArgs = {
  selectionId: Scalars["Int"]["input"];
};

export type RootMutationApproveActivityLinkArgs = {
  canonicalActivityId?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["Int"]["input"];
};

export type RootMutationCancelScheduledSessionArgs = {
  reason?: InputMaybe<Scalars["String"]["input"]>;
  session_id: Scalars["Int"]["input"];
};

export type RootMutationCreateActivityArgs = {
  activity_type: Scalars["String"]["input"];
  actor: Scalars["String"]["input"];
  link?: InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  requires_response?: InputMaybe<Scalars["Boolean"]["input"]>;
  title: Scalars["String"]["input"];
};

export type RootMutationCreateConversationStarterCardArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  gender_specific?: InputMaybe<Scalars["String"]["input"]>;
  prompt?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Scalars["String"]["input"]>;
  tier?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationCreateIntimacyActivityArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  is_shared?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationCreateScheduledSessionArgs = {
  activity_type?: InputMaybe<Scalars["String"]["input"]>;
  created_by: Scalars["String"]["input"];
  is_immediate?: InputMaybe<Scalars["Boolean"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_for?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationCreateUserArgs = {
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationDeleteConversationStarterCardArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RootMutationDeleteIntimacyActivityArgs = {
  id: Scalars["Int"]["input"];
};

export type RootMutationDeleteIntimacySessionArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationDeleteScheduledSessionArgs = {
  session_id: Scalars["Int"]["input"];
};

export type RootMutationLinkActivityToCanonicalArgs = {
  canonicalActivityId: Scalars["Int"]["input"];
  id: Scalars["Int"]["input"];
};

export type RootMutationLogIntimacySessionArgs = {
  activities_husband?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  activities_shared?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  activities_wife?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  duration_minutes?: InputMaybe<Scalars["Int"]["input"]>;
  husband_orgasm_count?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  initiator?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  substances?: InputMaybe<Array<InputMaybe<SubstanceInput>>>;
  time?: InputMaybe<Scalars["String"]["input"]>;
  wife_orgasm_count?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationLogPeriodDayArgs = {
  date: Scalars["String"]["input"];
  is_period: Scalars["Boolean"]["input"];
};

export type RootMutationMarkActivitiesReadArgs = {
  activity_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  mark_all?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RootMutationMarkSessionOutcomeArgs = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  outcome: Scalars["String"]["input"];
  session_id: Scalars["Int"]["input"];
};

export type RootMutationNotifyEmailChangeArgs = {
  context?: InputMaybe<Scalars["String"]["input"]>;
  newEmail: Scalars["String"]["input"];
  originalEmail: Scalars["String"]["input"];
  spouse?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationRejectActivityLinkArgs = {
  id: Scalars["Int"]["input"];
};

export type RootMutationRemoveCustomIntimacyActivityArgs = {
  activity: Scalars["String"]["input"];
};

export type RootMutationRemoveReactionArgs = {
  activity_id: Scalars["Int"]["input"];
  emoji: Scalars["String"]["input"];
};

export type RootMutationRespondToActivityArgs = {
  activity_id: Scalars["Int"]["input"];
  response_note?: InputMaybe<Scalars["String"]["input"]>;
  response_status: Scalars["String"]["input"];
};

export type RootMutationRespondToConversationStarterArgs = {
  actor?: InputMaybe<Scalars["String"]["input"]>;
  card_id?: InputMaybe<Scalars["ID"]["input"]>;
  excludeTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  reason_code?: InputMaybe<Scalars["String"]["input"]>;
  reason_note?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationRespondToMissedPredictionArgs = {
  date: Scalars["String"]["input"];
  response: Scalars["String"]["input"];
};

export type RootMutationRespondToScheduledSessionArgs = {
  response_note?: InputMaybe<Scalars["String"]["input"]>;
  session_id: Scalars["Int"]["input"];
  status: Scalars["String"]["input"];
};

export type RootMutationScheduleReminderArgs = {
  contact: Scalars["String"]["input"];
  daysFromNow?: InputMaybe<Scalars["Int"]["input"]>;
  link: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  minutesFromNow?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationSetConversationStarterCategoryPrefsArgs = {
  disabled_categories?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationSetPushExcludedActorArgs = {
  endpoint?: InputMaybe<Scalars["String"]["input"]>;
  excluded_actor: Scalars["String"]["input"];
};

export type RootMutationSubmitActivityRequestArgs = {
  activity_name: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationSubmitBugReportArgs = {
  description: Scalars["String"]["input"];
  deviceModel?: InputMaybe<Scalars["String"]["input"]>;
  deviceType?: InputMaybe<Scalars["String"]["input"]>;
  localPurchases?: InputMaybe<Scalars["JSON"]["input"]>;
  localUserData?: InputMaybe<Scalars["JSON"]["input"]>;
  page?: InputMaybe<Scalars["String"]["input"]>;
  screenSize?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  userAgent?: InputMaybe<Scalars["String"]["input"]>;
  viewportSize?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationSubmitIdeaArgs = {
  description: Scalars["String"]["input"];
  localPurchases?: InputMaybe<Scalars["JSON"]["input"]>;
  localUserData?: InputMaybe<Scalars["JSON"]["input"]>;
  page?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type RootMutationSubscribePushArgs = {
  auth: Scalars["String"]["input"];
  endpoint: Scalars["String"]["input"];
  p256dh: Scalars["String"]["input"];
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationTestEmailArgs = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationTestIntimacySuggestionArgs = {
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationTestPartnerActivityArgs = {
  message?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationTestPushNotificationArgs = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationTrackFeatureUsageArgs = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  feature_name: Scalars["String"]["input"];
  metadata?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationUnlinkActivityArgs = {
  id: Scalars["Int"]["input"];
};

export type RootMutationUnsubscribePushArgs = {
  endpoint: Scalars["String"]["input"];
};

export type RootMutationUpdateCommunicationPreferencesArgs = {
  husband_email?: InputMaybe<Scalars["String"]["input"]>;
  wife_email?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationUpdateConversationStarterCardArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  gender_specific?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  prompt?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Scalars["String"]["input"]>;
  tier?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationUpdateIntimacyActivityArgs = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_shared?: InputMaybe<Scalars["Boolean"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationUpdateIntimacyFrequencyPreferencesArgs = {
  intimacy_frequency_days?: InputMaybe<Scalars["Int"]["input"]>;
  intimacy_frequency_mode?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationUpdateSubstanceTrackingPreferenceArgs = {
  enable_substance_tracking: Scalars["Boolean"]["input"];
};

export type RootMutationUpdateUserSettingsArgs = {
  excluded_topics?: InputMaybe<Scalars["String"]["input"]>;
  oursexplorationlist_simplified_version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootMutationUpdateUserSexplorationListCurrentSessionArgs = {
  oursexplorationlist_current_session_id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RootMutationUpdateUserTimezoneArgs = {
  timezone: Scalars["String"]["input"];
};

export type RootQuery = {
  __typename?: "RootQuery";
  allConversationStarterCards?: Maybe<Array<Maybe<Conversation_Starter_Card>>>;
  conversationCategoryRemaining?: Maybe<Scalars["JSON"]["output"]>;
  conversationStarterCategoryPrefs?: Maybe<Scalars["String"]["output"]>;
  conversationStarterStats?: Maybe<Conversation_Starter_Stats>;
  getActivityReactions?: Maybe<Array<Maybe<ActivityReaction>>>;
  /** Get current user statistics for debugging */
  getAdminStats?: Maybe<Scalars["String"]["output"]>;
  getAnalyticsSummary: AnalyticsSummary;
  getCoupleEmails?: Maybe<CoupleEmails>;
  getCustomIntimacyActivities?: Maybe<
    Array<Maybe<Scalars["String"]["output"]>>
  >;
  getDailyUsageChart: Array<Maybe<DailyUsage>>;
  getFeatureUsageByPeriod: Array<Maybe<FeatureUsageStats>>;
  getIntimacyActivityUsageStats: Array<ActivityUsageStat>;
  getIntimacySessionsByDateRange?: Maybe<Array<Maybe<IntimacySession>>>;
  /** Get intimacy statistics for the current user */
  getIntimacyStats: IntimacyStats;
  getMissedPeriodPredictions?: Maybe<Array<MissedPrediction>>;
  getMyActivities?: Maybe<Array<Maybe<PartnerActivity>>>;
  getMyCycleCalendar: Array<DayWithPhase>;
  getMyCyclePrediction?: Maybe<CyclePrediction>;
  getMyIntimacySessions?: Maybe<Array<Maybe<IntimacySession>>>;
  getMyPeriodDays: Array<PeriodDay>;
  getMyPreferences?: Maybe<UserPreferences>;
  getPendingResponses?: Maybe<Array<Maybe<PartnerActivity>>>;
  getPendingSchedules?: Maybe<Array<Maybe<ScheduledIntimacySession>>>;
  getPushLogs?: Maybe<Array<Maybe<PushLog>>>;
  getScheduledSessions?: Maybe<Array<Maybe<ScheduledIntimacySession>>>;
  getUnreadActivityCount?: Maybe<Scalars["Int"]["output"]>;
  getUser?: Maybe<Array<Maybe<Ui_App_Users>>>;
  intimacyActivities: Array<IntimacyActivity>;
  intimacyActivitiesAdmin: Array<IntimacyActivityAdmin>;
  myCustomSubstances: Array<Scalars["String"]["output"]>;
  nextConversationStarters?: Maybe<Array<Maybe<Conversation_Starter_Card>>>;
};

export type RootQueryConversationStarterStatsArgs = {
  limit?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RootQueryGetActivityReactionsArgs = {
  activity_id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryGetAnalyticsSummaryArgs = {
  end_date?: InputMaybe<Scalars["String"]["input"]>;
  start_date?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryGetDailyUsageChartArgs = {
  days?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryGetFeatureUsageByPeriodArgs = {
  feature_name?: InputMaybe<Scalars["String"]["input"]>;
  period: Scalars["String"]["input"];
};

export type RootQueryGetIntimacySessionsByDateRangeArgs = {
  end_date?: InputMaybe<Scalars["String"]["input"]>;
  start_date?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryGetMyActivitiesArgs = {
  activity_type?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  since?: InputMaybe<Scalars["DateTime"]["input"]>;
  unread_only?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RootQueryGetMyCycleCalendarArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type RootQueryGetPushLogsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryGetScheduledSessionsArgs = {
  upcoming_only?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RootQueryGetUnreadActivityCountArgs = {
  exclude_actor?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryGetUserArgs = {
  user_id: Scalars["Int"]["input"];
};

export type RootQueryNextConversationStartersArgs = {
  allowedTiers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ScheduleReminderResult = {
  __typename?: "ScheduleReminderResult";
  message: Scalars["String"]["output"];
  reminderId?: Maybe<Scalars["Int"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type ScheduledIntimacySession = {
  __typename?: "ScheduledIntimacySession";
  activity_type: Scalars["String"]["output"];
  cancelled_at?: Maybe<Scalars["DateTime"]["output"]>;
  created_at: Scalars["DateTime"]["output"];
  created_by: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  is_immediate: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  responded_at?: Maybe<Scalars["DateTime"]["output"]>;
  response_note?: Maybe<Scalars["String"]["output"]>;
  scheduled_for?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["DateTime"]["output"];
  user_id: Scalars["Int"]["output"];
};

export type SubmitBugReportResult = {
  __typename?: "SubmitBugReportResult";
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type SubmitIdeaResult = {
  __typename?: "SubmitIdeaResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Substance = {
  __typename?: "Substance";
  amount?: Maybe<Scalars["String"]["output"]>;
  effectiveness?: Maybe<Scalars["Int"]["output"]>;
  person?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type SubstanceInput = {
  amount?: InputMaybe<Scalars["String"]["input"]>;
  effectiveness?: InputMaybe<Scalars["Int"]["input"]>;
  person?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type SubstanceStats = {
  __typename?: "SubstanceStats";
  total_sessions_with_substances: Scalars["Int"]["output"];
  usage_by_substance: Array<SubstanceUsage>;
};

export type SubstanceUsage = {
  __typename?: "SubstanceUsage";
  avg_dosage: Scalars["Float"]["output"];
  avg_effectiveness: Scalars["Float"]["output"];
  count: Scalars["Int"]["output"];
  sessions_with_substance: Scalars["Int"]["output"];
  substance: Scalars["String"]["output"];
  trend: Scalars["String"]["output"];
};

export type UserPreferences = {
  __typename?: "UserPreferences";
  custom_intimacy_activities?: Maybe<Array<Scalars["String"]["output"]>>;
  enable_substance_tracking: Scalars["Boolean"]["output"];
  husband_email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  intimacy_frequency_days?: Maybe<Scalars["Int"]["output"]>;
  intimacy_frequency_mode?: Maybe<Scalars["String"]["output"]>;
  user_id: Scalars["Int"]["output"];
  wife_email?: Maybe<Scalars["String"]["output"]>;
};

export type Conversation_Starter_Card = {
  __typename?: "conversation_starter_card";
  category?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["String"]["output"]>;
  gender_specific?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  prompt?: Maybe<Scalars["String"]["output"]>;
  tags?: Maybe<Scalars["String"]["output"]>;
  tier?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type Conversation_Starter_Card_Stat = {
  __typename?: "conversation_starter_card_stat";
  card_id?: Maybe<Scalars["ID"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  done_count?: Maybe<Scalars["Int"]["output"]>;
  prompt?: Maybe<Scalars["String"]["output"]>;
  skipped_count?: Maybe<Scalars["Int"]["output"]>;
  tier?: Maybe<Scalars["String"]["output"]>;
};

export type Conversation_Starter_Reason_Stat = {
  __typename?: "conversation_starter_reason_stat";
  count?: Maybe<Scalars["Int"]["output"]>;
  reason_code?: Maybe<Scalars["String"]["output"]>;
};

export type Conversation_Starter_Stats = {
  __typename?: "conversation_starter_stats";
  cards?: Maybe<Array<Maybe<Conversation_Starter_Card_Stat>>>;
  reasons?: Maybe<Array<Maybe<Conversation_Starter_Reason_Stat>>>;
  total_done?: Maybe<Scalars["Int"]["output"]>;
  total_skipped?: Maybe<Scalars["Int"]["output"]>;
};

export type Ui_App_Users = {
  __typename?: "ui_app_users";
  created_at?: Maybe<Scalars["String"]["output"]>;
  excluded_topics?: Maybe<Scalars["String"]["output"]>;
  oursexplorationlist_current_session_id?: Maybe<Scalars["Int"]["output"]>;
  oursexplorationlist_simplified_version?: Maybe<Scalars["Int"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
  user_id?: Maybe<Scalars["ID"]["output"]>;
};

export type GetActivityReactionsQueryVariables = Exact<{
  activity_id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetActivityReactionsQuery = {
  __typename?: "RootQuery";
  getActivityReactions?: Array<{
    __typename?: "ActivityReaction";
    id: number;
    activity_id: number;
    user_id: number;
    emoji: string;
    reactor: string;
    created_at: string;
  } | null> | null;
};

export type AddReactionMutationVariables = Exact<{
  activity_id: Scalars["Int"]["input"];
  emoji: Scalars["String"]["input"];
  reactor: Scalars["String"]["input"];
}>;

export type AddReactionMutation = {
  __typename?: "RootMutation";
  addReaction: {
    __typename?: "ActivityReaction";
    id: number;
    activity_id: number;
    user_id: number;
    emoji: string;
    reactor: string;
    created_at: string;
  };
};

export type RemoveReactionMutationVariables = Exact<{
  activity_id: Scalars["Int"]["input"];
  emoji: Scalars["String"]["input"];
}>;

export type RemoveReactionMutation = {
  __typename?: "RootMutation";
  removeReaction?: boolean | null;
};

export type SubmitBugReportMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  page?: InputMaybe<Scalars["String"]["input"]>;
  userAgent?: InputMaybe<Scalars["String"]["input"]>;
  deviceType?: InputMaybe<Scalars["String"]["input"]>;
  deviceModel?: InputMaybe<Scalars["String"]["input"]>;
  screenSize?: InputMaybe<Scalars["String"]["input"]>;
  viewportSize?: InputMaybe<Scalars["String"]["input"]>;
  localUserData?: InputMaybe<Scalars["JSON"]["input"]>;
  localPurchases?: InputMaybe<Scalars["JSON"]["input"]>;
}>;

export type SubmitBugReportMutation = {
  __typename?: "RootMutation";
  submitBugReport: {
    __typename?: "SubmitBugReportResult";
    success: boolean;
    message: string;
  };
};

export type SubmitIdeaMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  page?: InputMaybe<Scalars["String"]["input"]>;
  localUserData?: InputMaybe<Scalars["JSON"]["input"]>;
  localPurchases?: InputMaybe<Scalars["JSON"]["input"]>;
}>;

export type SubmitIdeaMutation = {
  __typename?: "RootMutation";
  submitIdea: {
    __typename?: "SubmitIdeaResult";
    success?: boolean | null;
    message?: string | null;
  };
};

export type GetAnalyticsSummaryQueryVariables = Exact<{
  start_date?: InputMaybe<Scalars["String"]["input"]>;
  end_date?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAnalyticsSummaryQuery = {
  __typename?: "RootQuery";
  getAnalyticsSummary: {
    __typename?: "AnalyticsSummary";
    total_users: number;
    feature_stats?: Array<{
      __typename?: "FeatureUsageStats";
      feature_name: string;
      yesterday: number;
      last_week: number;
      last_month: number;
      last_quarter: number;
      last_year: number;
      all_time: number;
    } | null> | null;
    daily_usage?: Array<{
      __typename?: "DailyUsage";
      date: string;
      feature_name: string;
      total_uses: number;
      unique_users: number;
    } | null> | null;
  };
};

export type GetFeatureUsageByPeriodQueryVariables = Exact<{
  period: Scalars["String"]["input"];
  feature_name?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeatureUsageByPeriodQuery = {
  __typename?: "RootQuery";
  getFeatureUsageByPeriod: Array<{
    __typename?: "FeatureUsageStats";
    feature_name: string;
    yesterday: number;
    last_week: number;
    last_month: number;
    last_quarter: number;
    last_year: number;
    all_time: number;
  } | null>;
};

export type GetDailyUsageChartQueryVariables = Exact<{
  days?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDailyUsageChartQuery = {
  __typename?: "RootQuery";
  getDailyUsageChart: Array<{
    __typename?: "DailyUsage";
    date: string;
    feature_name: string;
    total_uses: number;
    unique_users: number;
  } | null>;
};

export type TrackFeatureUsageMutationVariables = Exact<{
  feature_name: Scalars["String"]["input"];
  action?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TrackFeatureUsageMutation = {
  __typename?: "RootMutation";
  trackFeatureUsage?: boolean | null;
};

export type NextConversationStartersQueryVariables = Exact<{
  category?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  allowedTiers?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type NextConversationStartersQuery = {
  __typename?: "RootQuery";
  nextConversationStarters?: Array<{
    __typename?: "conversation_starter_card";
    id?: string | null;
    prompt?: string | null;
    category?: string | null;
    tags?: string | null;
    tier?: string | null;
  } | null> | null;
};

export type RespondToConversationStarterMutationVariables = Exact<{
  card_id?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  reason_code?: InputMaybe<Scalars["String"]["input"]>;
  reason_note?: InputMaybe<Scalars["String"]["input"]>;
  excludeTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  actor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RespondToConversationStarterMutation = {
  __typename?: "RootMutation";
  respondToConversationStarter?: {
    __typename?: "Response";
    success?: boolean | null;
    message?: string | null;
  } | null;
};

export type ConversationStarterCategoryPrefsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ConversationStarterCategoryPrefsQuery = {
  __typename?: "RootQuery";
  conversationStarterCategoryPrefs?: string | null;
};

export type ConversationCategoryRemainingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ConversationCategoryRemainingQuery = {
  __typename?: "RootQuery";
  conversationCategoryRemaining?: Record<string, unknown> | null;
};

export type AllConversationStarterCardsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllConversationStarterCardsQuery = {
  __typename?: "RootQuery";
  allConversationStarterCards?: Array<{
    __typename?: "conversation_starter_card";
    id?: string | null;
    prompt?: string | null;
    category?: string | null;
    tags?: string | null;
    tier?: string | null;
    gender_specific?: string | null;
    is_active?: boolean | null;
  } | null> | null;
};

export type CreateConversationStarterCardMutationVariables = Exact<{
  prompt?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  tier?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Scalars["String"]["input"]>;
  gender_specific?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateConversationStarterCardMutation = {
  __typename?: "RootMutation";
  createConversationStarterCard?: {
    __typename?: "conversation_starter_card";
    id?: string | null;
  } | null;
};

export type UpdateConversationStarterCardMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
  prompt?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  tier?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Scalars["String"]["input"]>;
  gender_specific?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateConversationStarterCardMutation = {
  __typename?: "RootMutation";
  updateConversationStarterCard?: {
    __typename?: "conversation_starter_card";
    id?: string | null;
  } | null;
};

export type DeleteConversationStarterCardMutationVariables = Exact<{
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type DeleteConversationStarterCardMutation = {
  __typename?: "RootMutation";
  deleteConversationStarterCard?: {
    __typename?: "Response";
    success?: boolean | null;
  } | null;
};

export type SetConversationStarterCategoryPrefsMutationVariables = Exact<{
  disabled_categories?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SetConversationStarterCategoryPrefsMutation = {
  __typename?: "RootMutation";
  setConversationStarterCategoryPrefs?: {
    __typename?: "Response";
    success?: boolean | null;
  } | null;
};

export type ConversationStarterStatsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type ConversationStarterStatsQuery = {
  __typename?: "RootQuery";
  conversationStarterStats?: {
    __typename?: "conversation_starter_stats";
    total_done?: number | null;
    total_skipped?: number | null;
    cards?: Array<{
      __typename?: "conversation_starter_card_stat";
      card_id?: string | null;
      prompt?: string | null;
      category?: string | null;
      tier?: string | null;
      done_count?: number | null;
      skipped_count?: number | null;
    } | null> | null;
    reasons?: Array<{
      __typename?: "conversation_starter_reason_stat";
      reason_code?: string | null;
      count?: number | null;
    } | null> | null;
  } | null;
};

export type GetCoupleEmailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoupleEmailsQuery = {
  __typename?: "RootQuery";
  getCoupleEmails?: {
    __typename?: "CoupleEmails";
    husbandEmail?: string | null;
    wifeEmail?: string | null;
    primaryEmail?: string | null;
  } | null;
};

export type GetIntimacyActivitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIntimacyActivitiesQuery = {
  __typename?: "RootQuery";
  intimacyActivities: Array<{
    __typename?: "IntimacyActivity";
    id: number;
    name: string;
    label: string;
    category?: string | null;
    is_active: boolean;
    is_shared: boolean;
    user_id?: number | null;
    sort_order: number;
    created_at: string;
  }>;
};

export type GetMyCustomSubstancesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyCustomSubstancesQuery = {
  __typename?: "RootQuery";
  myCustomSubstances: Array<string>;
};

export type GetMyCyclePredictionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyCyclePredictionQuery = {
  __typename?: "RootQuery";
  getMyCyclePrediction?: {
    __typename?: "CyclePrediction";
    average_cycle_length?: number | null;
    average_period_length?: number | null;
    next_period_start?: string | null;
    next_period_end?: string | null;
    next_ovulation?: string | null;
    fertile_window_start?: string | null;
    fertile_window_end?: string | null;
  } | null;
};

export type GetMyCycleCalendarQueryVariables = Exact<{
  startDate: Scalars["String"]["input"];
  endDate: Scalars["String"]["input"];
}>;

export type GetMyCycleCalendarQuery = {
  __typename?: "RootQuery";
  getMyCycleCalendar: Array<{
    __typename?: "DayWithPhase";
    date: string;
    is_period: boolean;
    phase: CyclePhase;
    is_predicted: boolean;
  }>;
};

export type LogPeriodDayMutationVariables = Exact<{
  date: Scalars["String"]["input"];
  is_period: Scalars["Boolean"]["input"];
}>;

export type LogPeriodDayMutation = {
  __typename?: "RootMutation";
  logPeriodDay: {
    __typename?: "PeriodDay";
    id: number;
    date: string;
    is_period: boolean;
  };
};

export type GetMissedPeriodPredictionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMissedPeriodPredictionsQuery = {
  __typename?: "RootQuery";
  getMissedPeriodPredictions?: Array<{
    __typename?: "MissedPrediction";
    date: string;
    days_ago: number;
    is_continuation: boolean;
  }> | null;
};

export type RespondToMissedPredictionMutationVariables = Exact<{
  date: Scalars["String"]["input"];
  response: Scalars["String"]["input"];
}>;

export type RespondToMissedPredictionMutation = {
  __typename?: "RootMutation";
  respondToMissedPrediction: boolean;
};

export type GetIntimacySessionsByDateRangeQueryVariables = Exact<{
  start_date: Scalars["String"]["input"];
  end_date: Scalars["String"]["input"];
}>;

export type GetIntimacySessionsByDateRangeQuery = {
  __typename?: "RootQuery";
  getIntimacySessionsByDateRange?: Array<{
    __typename?: "IntimacySession";
    id?: number | null;
    date?: string | null;
    time?: string | null;
    duration_minutes?: number | null;
    husband_orgasm_count?: number | null;
    wife_orgasm_count?: number | null;
    initiator?: string | null;
    activities_husband?: Array<string | null> | null;
    activities_wife?: Array<string | null> | null;
    activities_shared?: Array<string | null> | null;
    notes?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    substances?: Array<{
      __typename?: "Substance";
      person?: string | null;
      type?: string | null;
      amount?: string | null;
      effectiveness?: number | null;
    } | null> | null;
  } | null> | null;
};

export type LogIntimacySessionMutationVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>;
  date: Scalars["String"]["input"];
  time?: InputMaybe<Scalars["String"]["input"]>;
  duration_minutes?: InputMaybe<Scalars["Int"]["input"]>;
  husband_orgasm_count?: InputMaybe<Scalars["Int"]["input"]>;
  wife_orgasm_count?: InputMaybe<Scalars["Int"]["input"]>;
  initiator?: InputMaybe<Scalars["String"]["input"]>;
  activities_husband?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  activities_wife?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  activities_shared?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  substances?: InputMaybe<
    Array<InputMaybe<SubstanceInput>> | InputMaybe<SubstanceInput>
  >;
  notes?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LogIntimacySessionMutation = {
  __typename?: "RootMutation";
  logIntimacySession?: {
    __typename?: "IntimacySession";
    id?: number | null;
    date?: string | null;
    time?: string | null;
    duration_minutes?: number | null;
    husband_orgasm_count?: number | null;
    wife_orgasm_count?: number | null;
    initiator?: string | null;
    activities_husband?: Array<string | null> | null;
    activities_wife?: Array<string | null> | null;
    activities_shared?: Array<string | null> | null;
    notes?: string | null;
    substances?: Array<{
      __typename?: "Substance";
      person?: string | null;
      type?: string | null;
      amount?: string | null;
      effectiveness?: number | null;
    } | null> | null;
  } | null;
};

export type DeleteIntimacySessionMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteIntimacySessionMutation = {
  __typename?: "RootMutation";
  deleteIntimacySession?: boolean | null;
};

export type GetCustomIntimacyActivitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCustomIntimacyActivitiesQuery = {
  __typename?: "RootQuery";
  getCustomIntimacyActivities?: Array<string | null> | null;
};

export type AddCustomIntimacyActivityMutationVariables = Exact<{
  activity: Scalars["String"]["input"];
}>;

export type AddCustomIntimacyActivityMutation = {
  __typename?: "RootMutation";
  addCustomIntimacyActivity?: {
    __typename?: "UserPreferences";
    id: number;
    custom_intimacy_activities?: Array<string> | null;
  } | null;
};

export type RemoveCustomIntimacyActivityMutationVariables = Exact<{
  activity: Scalars["String"]["input"];
}>;

export type RemoveCustomIntimacyActivityMutation = {
  __typename?: "RootMutation";
  removeCustomIntimacyActivity?: {
    __typename?: "UserPreferences";
    id: number;
    custom_intimacy_activities?: Array<string> | null;
  } | null;
};

export type SubmitActivityRequestMutationVariables = Exact<{
  activity_name: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SubmitActivityRequestMutation = {
  __typename?: "RootMutation";
  submitActivityRequest?: boolean | null;
};

export type GetIntimacyStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetIntimacyStatsQuery = {
  __typename?: "RootQuery";
  getIntimacyStats: {
    __typename?: "IntimacyStats";
    total_sessions: number;
    avg_sessions_per_week: number;
    avg_days_between_sessions: number;
    total_husband_orgasms: number;
    total_wife_orgasms: number;
    avg_husband_orgasms_per_session: number;
    avg_wife_orgasms_per_session: number;
    avg_duration_minutes: number;
    days_since_last_intimacy?: number | null;
    days_since_husband_orgasm?: number | null;
    days_since_wife_orgasm?: number | null;
    days_since_husband_initiated?: number | null;
    days_since_wife_initiated?: number | null;
    mutual_orgasm_rate: number;
    orgasm_gap: number;
    orgasm_ratio_husband: number;
    orgasm_ratio_wife: number;
    orgasm_ratio_husband_recent: number;
    orgasm_ratio_wife_recent: number;
    activity_diversity: number;
    sessions_with_zero_orgasms: number;
    most_common_day_of_week?: string | null;
    time_between_sessions_trend?: string | null;
    current_streak: number;
    median_duration_minutes: number;
    new_activities_this_month: Array<string>;
    longest_gap_days: number;
    sessions_this_week: number;
    activity_counts: Array<{
      __typename?: "ActivityStats";
      activity: string;
      count: number;
      orgasm_correlation: number;
    }>;
    activity_counts_husband: Array<{
      __typename?: "ActivityStats";
      activity: string;
      count: number;
      orgasm_correlation: number;
    }>;
    activity_counts_wife: Array<{
      __typename?: "ActivityStats";
      activity: string;
      count: number;
      orgasm_correlation: number;
    }>;
    initiator_counts: {
      __typename?: "InitiatorCounts";
      husband: number;
      wife: number;
      mutual: number;
    };
    cycle_prediction?: {
      __typename?: "CyclePrediction";
      average_cycle_length?: number | null;
      average_period_length?: number | null;
    } | null;
    substance_stats: {
      __typename?: "SubstanceStats";
      total_sessions_with_substances: number;
      usage_by_substance: Array<{
        __typename?: "SubstanceUsage";
        substance: string;
        count: number;
        avg_dosage: number;
        avg_effectiveness: number;
        sessions_with_substance: number;
        trend: string;
      }>;
    };
  };
};

export type GetIntimacyActivitiesAdminQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIntimacyActivitiesAdminQuery = {
  __typename?: "RootQuery";
  intimacyActivitiesAdmin: Array<{
    __typename?: "IntimacyActivityAdmin";
    id: number;
    name: string;
    label: string;
    category?: string | null;
    is_active: boolean;
    is_shared: boolean;
    user_id?: number | null;
    sort_order: number;
    created_at: string;
    canonical_activity_id?: number | null;
    link_status?: string | null;
    link_suggestion_score?: number | null;
    canonical_activity?: {
      __typename?: "IntimacyActivityAdmin";
      id: number;
      name: string;
      label: string;
    } | null;
  }>;
};

export type GetIntimacyActivityUsageStatsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIntimacyActivityUsageStatsQuery = {
  __typename?: "RootQuery";
  getIntimacyActivityUsageStats: Array<{
    __typename?: "ActivityUsageStat";
    activity_name: string;
    activity_label: string;
    count: number;
    distinct_users: number;
  }>;
};

export type RescanActivityLinkSuggestionsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RescanActivityLinkSuggestionsMutation = {
  __typename?: "RootMutation";
  rescanActivityLinkSuggestions: number;
};

export type ApproveActivityLinkMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  canonicalActivityId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ApproveActivityLinkMutation = {
  __typename?: "RootMutation";
  approveActivityLink: {
    __typename?: "ActivityLinkResult";
    id?: number | null;
    canonical_activity_id?: number | null;
    link_status: string;
    link_suggestion_score?: number | null;
  };
};

export type RejectActivityLinkMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type RejectActivityLinkMutation = {
  __typename?: "RootMutation";
  rejectActivityLink: {
    __typename?: "ActivityLinkResult";
    id?: number | null;
    canonical_activity_id?: number | null;
    link_status: string;
    link_suggestion_score?: number | null;
  };
};

export type LinkActivityToCanonicalMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  canonicalActivityId: Scalars["Int"]["input"];
}>;

export type LinkActivityToCanonicalMutation = {
  __typename?: "RootMutation";
  linkActivityToCanonical: {
    __typename?: "ActivityLinkResult";
    id?: number | null;
    canonical_activity_id?: number | null;
    link_status: string;
    link_suggestion_score?: number | null;
  };
};

export type UnlinkActivityMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type UnlinkActivityMutation = {
  __typename?: "RootMutation";
  unlinkActivity: {
    __typename?: "ActivityLinkResult";
    id?: number | null;
    canonical_activity_id?: number | null;
    link_status: string;
    link_suggestion_score?: number | null;
  };
};

export type CreateIntimacyActivityMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  label: Scalars["String"]["input"];
  category?: InputMaybe<Scalars["String"]["input"]>;
  is_shared?: InputMaybe<Scalars["Boolean"]["input"]>;
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateIntimacyActivityMutation = {
  __typename?: "RootMutation";
  createIntimacyActivity: {
    __typename?: "IntimacyActivityMutation";
    id?: number | null;
    name?: string | null;
    label?: string | null;
    category?: string | null;
    is_active?: boolean | null;
    is_shared?: boolean | null;
    user_id?: number | null;
    sort_order?: number | null;
    created_at?: string | null;
  };
};

export type UpdateIntimacyActivityMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_shared?: InputMaybe<Scalars["Boolean"]["input"]>;
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateIntimacyActivityMutation = {
  __typename?: "RootMutation";
  updateIntimacyActivity: {
    __typename?: "IntimacyActivityMutation";
    id?: number | null;
    name?: string | null;
    label?: string | null;
    category?: string | null;
    is_active?: boolean | null;
    is_shared?: boolean | null;
    user_id?: number | null;
    sort_order?: number | null;
    created_at?: string | null;
  };
};

export type DeleteIntimacyActivityMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteIntimacyActivityMutation = {
  __typename?: "RootMutation";
  deleteIntimacyActivity: boolean;
};

export type PartnerActivityFieldsFragment = {
  __typename?: "PartnerActivity";
  id: number;
  user_id: number;
  activity_type: string;
  actor: string;
  title: string;
  message?: string | null;
  link?: string | null;
  metadata?: Record<string, unknown> | null;
  is_read: boolean;
  requires_response: boolean;
  response_status?: string | null;
  response_note?: string | null;
  responded_at?: string | null;
  created_at: string;
};

export type GetMyActivitiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  unread_only?: InputMaybe<Scalars["Boolean"]["input"]>;
  activity_type?: InputMaybe<Scalars["String"]["input"]>;
  since?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type GetMyActivitiesQuery = {
  __typename?: "RootQuery";
  getMyActivities?: Array<{
    __typename?: "PartnerActivity";
    id: number;
    user_id: number;
    activity_type: string;
    actor: string;
    title: string;
    message?: string | null;
    link?: string | null;
    metadata?: Record<string, unknown> | null;
    is_read: boolean;
    requires_response: boolean;
    response_status?: string | null;
    response_note?: string | null;
    responded_at?: string | null;
    created_at: string;
  } | null> | null;
};

export type GetUnreadActivityCountQueryVariables = Exact<{
  exclude_actor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetUnreadActivityCountQuery = {
  __typename?: "RootQuery";
  getUnreadActivityCount?: number | null;
};

export type GetPendingResponsesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingResponsesQuery = {
  __typename?: "RootQuery";
  getPendingResponses?: Array<{
    __typename?: "PartnerActivity";
    id: number;
    user_id: number;
    activity_type: string;
    actor: string;
    title: string;
    message?: string | null;
    link?: string | null;
    metadata?: Record<string, unknown> | null;
    is_read: boolean;
    requires_response: boolean;
    response_status?: string | null;
    response_note?: string | null;
    responded_at?: string | null;
    created_at: string;
  } | null> | null;
};

export type CreateActivityMutationVariables = Exact<{
  activity_type: Scalars["String"]["input"];
  actor: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  requires_response?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateActivityMutation = {
  __typename?: "RootMutation";
  createActivity: {
    __typename?: "PartnerActivity";
    id: number;
    created_at: string;
  };
};

export type MarkActivitiesReadMutationVariables = Exact<{
  activity_ids?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  mark_all?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type MarkActivitiesReadMutation = {
  __typename?: "RootMutation";
  markActivitiesRead?: boolean | null;
};

export type RespondToActivityMutationVariables = Exact<{
  activity_id: Scalars["Int"]["input"];
  response_status: Scalars["String"]["input"];
  response_note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RespondToActivityMutation = {
  __typename?: "RootMutation";
  respondToActivity: {
    __typename?: "PartnerActivity";
    id: number;
    user_id: number;
    activity_type: string;
    actor: string;
    title: string;
    message?: string | null;
    link?: string | null;
    metadata?: Record<string, unknown> | null;
    is_read: boolean;
    requires_response: boolean;
    response_status?: string | null;
    response_note?: string | null;
    responded_at?: string | null;
    created_at: string;
  };
};

export type SubscribePushMutationVariables = Exact<{
  endpoint: Scalars["String"]["input"];
  p256dh: Scalars["String"]["input"];
  auth: Scalars["String"]["input"];
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SubscribePushMutation = {
  __typename?: "RootMutation";
  subscribePush?: {
    __typename?: "PushSubscription";
    id: number;
    endpoint: string;
  } | null;
};

export type UnsubscribePushMutationVariables = Exact<{
  endpoint: Scalars["String"]["input"];
}>;

export type UnsubscribePushMutation = {
  __typename?: "RootMutation";
  unsubscribePush?: boolean | null;
};

export type ScheduleReminderMutationVariables = Exact<{
  contact: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  link: Scalars["String"]["input"];
  daysFromNow?: InputMaybe<Scalars["Int"]["input"]>;
  minutesFromNow?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ScheduleReminderMutation = {
  __typename?: "RootMutation";
  scheduleReminder?: {
    __typename?: "ScheduleReminderResult";
    success: boolean;
    message: string;
    reminderId?: number | null;
  } | null;
};

export type SetPushExcludedActorMutationVariables = Exact<{
  excluded_actor: Scalars["String"]["input"];
  endpoint?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SetPushExcludedActorMutation = {
  __typename?: "RootMutation";
  setPushExcludedActor?: number | null;
};

export type ScheduledSessionFieldsFragment = {
  __typename?: "ScheduledIntimacySession";
  id: number;
  user_id: number;
  scheduled_for?: string | null;
  title?: string | null;
  message?: string | null;
  created_by: string;
  status: string;
  activity_type: string;
  is_immediate: boolean;
  response_note?: string | null;
  responded_at?: string | null;
  cancelled_at?: string | null;
  created_at: string;
  updated_at: string;
};

export type GetScheduledSessionsQueryVariables = Exact<{
  upcoming_only?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetScheduledSessionsQuery = {
  __typename?: "RootQuery";
  getScheduledSessions?: Array<{
    __typename?: "ScheduledIntimacySession";
    id: number;
    user_id: number;
    scheduled_for?: string | null;
    title?: string | null;
    message?: string | null;
    created_by: string;
    status: string;
    activity_type: string;
    is_immediate: boolean;
    response_note?: string | null;
    responded_at?: string | null;
    cancelled_at?: string | null;
    created_at: string;
    updated_at: string;
  } | null> | null;
};

export type GetPendingSchedulesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingSchedulesQuery = {
  __typename?: "RootQuery";
  getPendingSchedules?: Array<{
    __typename?: "ScheduledIntimacySession";
    id: number;
    user_id: number;
    scheduled_for?: string | null;
    title?: string | null;
    message?: string | null;
    created_by: string;
    status: string;
    activity_type: string;
    is_immediate: boolean;
    response_note?: string | null;
    responded_at?: string | null;
    cancelled_at?: string | null;
    created_at: string;
    updated_at: string;
  } | null> | null;
};

export type CreateScheduledSessionMutationVariables = Exact<{
  scheduled_for?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  created_by: Scalars["String"]["input"];
  activity_type?: InputMaybe<Scalars["String"]["input"]>;
  is_immediate?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateScheduledSessionMutation = {
  __typename?: "RootMutation";
  createScheduledSession: {
    __typename?: "ScheduledIntimacySession";
    id: number;
    user_id: number;
    scheduled_for?: string | null;
    title?: string | null;
    message?: string | null;
    created_by: string;
    status: string;
    activity_type: string;
    is_immediate: boolean;
    response_note?: string | null;
    responded_at?: string | null;
    cancelled_at?: string | null;
    created_at: string;
    updated_at: string;
  };
};

export type RespondToScheduledSessionMutationVariables = Exact<{
  session_id: Scalars["Int"]["input"];
  status: Scalars["String"]["input"];
  response_note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RespondToScheduledSessionMutation = {
  __typename?: "RootMutation";
  respondToScheduledSession: {
    __typename?: "ScheduledIntimacySession";
    id: number;
    user_id: number;
    scheduled_for?: string | null;
    title?: string | null;
    message?: string | null;
    created_by: string;
    status: string;
    activity_type: string;
    is_immediate: boolean;
    response_note?: string | null;
    responded_at?: string | null;
    cancelled_at?: string | null;
    created_at: string;
    updated_at: string;
  };
};

export type CancelScheduledSessionMutationVariables = Exact<{
  session_id: Scalars["Int"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CancelScheduledSessionMutation = {
  __typename?: "RootMutation";
  cancelScheduledSession: {
    __typename?: "ScheduledIntimacySession";
    id: number;
    user_id: number;
    scheduled_for?: string | null;
    title?: string | null;
    message?: string | null;
    created_by: string;
    status: string;
    activity_type: string;
    is_immediate: boolean;
    response_note?: string | null;
    responded_at?: string | null;
    cancelled_at?: string | null;
    created_at: string;
    updated_at: string;
  };
};

export type MarkSessionOutcomeMutationVariables = Exact<{
  session_id: Scalars["Int"]["input"];
  outcome: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MarkSessionOutcomeMutation = {
  __typename?: "RootMutation";
  markSessionOutcome: {
    __typename?: "ScheduledIntimacySession";
    id: number;
    user_id: number;
    scheduled_for?: string | null;
    title?: string | null;
    message?: string | null;
    created_by: string;
    status: string;
    activity_type: string;
    is_immediate: boolean;
    response_note?: string | null;
    responded_at?: string | null;
    cancelled_at?: string | null;
    created_at: string;
    updated_at: string;
  };
};

export type DeleteScheduledSessionMutationVariables = Exact<{
  session_id: Scalars["Int"]["input"];
}>;

export type DeleteScheduledSessionMutation = {
  __typename?: "RootMutation";
  deleteScheduledSession: boolean;
};

export type UserPreferencesFieldsFragment = {
  __typename?: "UserPreferences";
  id: number;
  user_id: number;
  custom_intimacy_activities?: Array<string> | null;
  husband_email?: string | null;
  wife_email?: string | null;
  intimacy_frequency_mode?: string | null;
  intimacy_frequency_days?: number | null;
  enable_substance_tracking: boolean;
};

export type GetMyPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPreferencesQuery = {
  __typename?: "RootQuery";
  getMyPreferences?: {
    __typename?: "UserPreferences";
    id: number;
    user_id: number;
    custom_intimacy_activities?: Array<string> | null;
    husband_email?: string | null;
    wife_email?: string | null;
    intimacy_frequency_mode?: string | null;
    intimacy_frequency_days?: number | null;
    enable_substance_tracking: boolean;
  } | null;
};

export type UpdateCommunicationPreferencesMutationVariables = Exact<{
  husband_email?: InputMaybe<Scalars["String"]["input"]>;
  wife_email?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateCommunicationPreferencesMutation = {
  __typename?: "RootMutation";
  updateCommunicationPreferences: {
    __typename?: "UserPreferences";
    id: number;
    user_id: number;
    custom_intimacy_activities?: Array<string> | null;
    husband_email?: string | null;
    wife_email?: string | null;
    intimacy_frequency_mode?: string | null;
    intimacy_frequency_days?: number | null;
    enable_substance_tracking: boolean;
  };
};

export type UpdateIntimacyFrequencyPreferencesMutationVariables = Exact<{
  intimacy_frequency_mode?: InputMaybe<Scalars["String"]["input"]>;
  intimacy_frequency_days?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateIntimacyFrequencyPreferencesMutation = {
  __typename?: "RootMutation";
  updateIntimacyFrequencyPreferences: {
    __typename?: "UserPreferences";
    id: number;
    user_id: number;
    custom_intimacy_activities?: Array<string> | null;
    husband_email?: string | null;
    wife_email?: string | null;
    intimacy_frequency_mode?: string | null;
    intimacy_frequency_days?: number | null;
    enable_substance_tracking: boolean;
  };
};

export type UpdateSubstanceTrackingPreferenceMutationVariables = Exact<{
  enable_substance_tracking: Scalars["Boolean"]["input"];
}>;

export type UpdateSubstanceTrackingPreferenceMutation = {
  __typename?: "RootMutation";
  updateSubstanceTrackingPreference: {
    __typename?: "UserPreferences";
    id: number;
    user_id: number;
    custom_intimacy_activities?: Array<string> | null;
    husband_email?: string | null;
    wife_email?: string | null;
    intimacy_frequency_mode?: string | null;
    intimacy_frequency_days?: number | null;
    enable_substance_tracking: boolean;
  };
};

export const PartnerActivityFieldsFragmentDoc = gql`
  fragment PartnerActivityFields on PartnerActivity {
    id
    user_id
    activity_type
    actor
    title
    message
    link
    metadata
    is_read
    requires_response
    response_status
    response_note
    responded_at
    created_at
  }
`;
export const ScheduledSessionFieldsFragmentDoc = gql`
  fragment ScheduledSessionFields on ScheduledIntimacySession {
    id
    user_id
    scheduled_for
    title
    message
    created_by
    status
    activity_type
    is_immediate
    response_note
    responded_at
    cancelled_at
    created_at
    updated_at
  }
`;
export const UserPreferencesFieldsFragmentDoc = gql`
  fragment UserPreferencesFields on UserPreferences {
    id
    user_id
    custom_intimacy_activities
    husband_email
    wife_email
    intimacy_frequency_mode
    intimacy_frequency_days
    enable_substance_tracking
  }
`;
export const GetActivityReactionsDocument = gql`
  query GetActivityReactions($activity_id: Int) {
    getActivityReactions(activity_id: $activity_id) {
      id
      activity_id
      user_id
      emoji
      reactor
      created_at
    }
  }
`;
export const AddReactionDocument = gql`
  mutation AddReaction($activity_id: Int!, $emoji: String!, $reactor: String!) {
    addReaction(activity_id: $activity_id, emoji: $emoji, reactor: $reactor) {
      id
      activity_id
      user_id
      emoji
      reactor
      created_at
    }
  }
`;
export const RemoveReactionDocument = gql`
  mutation RemoveReaction($activity_id: Int!, $emoji: String!) {
    removeReaction(activity_id: $activity_id, emoji: $emoji)
  }
`;
export const SubmitBugReportDocument = gql`
  mutation SubmitBugReport(
    $title: String!
    $description: String!
    $page: String
    $userAgent: String
    $deviceType: String
    $deviceModel: String
    $screenSize: String
    $viewportSize: String
    $localUserData: JSON
    $localPurchases: JSON
  ) {
    submitBugReport(
      title: $title
      description: $description
      page: $page
      userAgent: $userAgent
      deviceType: $deviceType
      deviceModel: $deviceModel
      screenSize: $screenSize
      viewportSize: $viewportSize
      localUserData: $localUserData
      localPurchases: $localPurchases
    ) {
      success
      message
    }
  }
`;
export const SubmitIdeaDocument = gql`
  mutation SubmitIdea(
    $title: String!
    $description: String!
    $page: String
    $localUserData: JSON
    $localPurchases: JSON
  ) {
    submitIdea(
      title: $title
      description: $description
      page: $page
      localUserData: $localUserData
      localPurchases: $localPurchases
    ) {
      success
      message
    }
  }
`;
export const GetAnalyticsSummaryDocument = gql`
  query GetAnalyticsSummary($start_date: String, $end_date: String) {
    getAnalyticsSummary(start_date: $start_date, end_date: $end_date) {
      total_users
      feature_stats {
        feature_name
        yesterday
        last_week
        last_month
        last_quarter
        last_year
        all_time
      }
      daily_usage {
        date
        feature_name
        total_uses
        unique_users
      }
    }
  }
`;
export const GetFeatureUsageByPeriodDocument = gql`
  query GetFeatureUsageByPeriod($period: String!, $feature_name: String) {
    getFeatureUsageByPeriod(period: $period, feature_name: $feature_name) {
      feature_name
      yesterday
      last_week
      last_month
      last_quarter
      last_year
      all_time
    }
  }
`;
export const GetDailyUsageChartDocument = gql`
  query GetDailyUsageChart($days: String) {
    getDailyUsageChart(days: $days) {
      date
      feature_name
      total_uses
      unique_users
    }
  }
`;
export const TrackFeatureUsageDocument = gql`
  mutation TrackFeatureUsage(
    $feature_name: String!
    $action: String
    $metadata: String
  ) {
    trackFeatureUsage(
      feature_name: $feature_name
      action: $action
      metadata: $metadata
    )
  }
`;
export const NextConversationStartersDocument = gql`
  query NextConversationStarters(
    $category: String
    $limit: Int
    $allowedTiers: [String]
  ) {
    nextConversationStarters(
      category: $category
      limit: $limit
      allowedTiers: $allowedTiers
    ) {
      id
      prompt
      category
      tags
      tier
    }
  }
`;
export const RespondToConversationStarterDocument = gql`
  mutation RespondToConversationStarter(
    $card_id: ID
    $status: String
    $reason_code: String
    $reason_note: String
    $excludeTopic: Boolean
    $actor: String
  ) {
    respondToConversationStarter(
      card_id: $card_id
      status: $status
      reason_code: $reason_code
      reason_note: $reason_note
      excludeTopic: $excludeTopic
      actor: $actor
    ) {
      success
      message
    }
  }
`;
export const ConversationStarterCategoryPrefsDocument = gql`
  query ConversationStarterCategoryPrefs {
    conversationStarterCategoryPrefs
  }
`;
export const ConversationCategoryRemainingDocument = gql`
  query ConversationCategoryRemaining {
    conversationCategoryRemaining
  }
`;
export const AllConversationStarterCardsDocument = gql`
  query AllConversationStarterCards {
    allConversationStarterCards {
      id
      prompt
      category
      tags
      tier
      gender_specific
      is_active
    }
  }
`;
export const CreateConversationStarterCardDocument = gql`
  mutation CreateConversationStarterCard(
    $prompt: String
    $category: String
    $tier: String
    $tags: String
    $gender_specific: String
  ) {
    createConversationStarterCard(
      prompt: $prompt
      category: $category
      tier: $tier
      tags: $tags
      gender_specific: $gender_specific
    ) {
      id
    }
  }
`;
export const UpdateConversationStarterCardDocument = gql`
  mutation UpdateConversationStarterCard(
    $id: ID
    $prompt: String
    $category: String
    $tier: String
    $tags: String
    $gender_specific: String
  ) {
    updateConversationStarterCard(
      id: $id
      prompt: $prompt
      category: $category
      tier: $tier
      tags: $tags
      gender_specific: $gender_specific
    ) {
      id
    }
  }
`;
export const DeleteConversationStarterCardDocument = gql`
  mutation DeleteConversationStarterCard($id: ID) {
    deleteConversationStarterCard(id: $id) {
      success
    }
  }
`;
export const SetConversationStarterCategoryPrefsDocument = gql`
  mutation SetConversationStarterCategoryPrefs($disabled_categories: String) {
    setConversationStarterCategoryPrefs(
      disabled_categories: $disabled_categories
    ) {
      success
    }
  }
`;
export const ConversationStarterStatsDocument = gql`
  query ConversationStarterStats($limit: ID) {
    conversationStarterStats(limit: $limit) {
      total_done
      total_skipped
      cards {
        card_id
        prompt
        category
        tier
        done_count
        skipped_count
      }
      reasons {
        reason_code
        count
      }
    }
  }
`;
export const GetCoupleEmailsDocument = gql`
  query GetCoupleEmails {
    getCoupleEmails {
      husbandEmail
      wifeEmail
      primaryEmail
    }
  }
`;
export const GetIntimacyActivitiesDocument = gql`
  query GetIntimacyActivities {
    intimacyActivities {
      id
      name
      label
      category
      is_active
      is_shared
      user_id
      sort_order
      created_at
    }
  }
`;
export const GetMyCustomSubstancesDocument = gql`
  query GetMyCustomSubstances {
    myCustomSubstances
  }
`;
export const GetMyCyclePredictionDocument = gql`
  query GetMyCyclePrediction {
    getMyCyclePrediction {
      average_cycle_length
      average_period_length
      next_period_start
      next_period_end
      next_ovulation
      fertile_window_start
      fertile_window_end
    }
  }
`;
export const GetMyCycleCalendarDocument = gql`
  query GetMyCycleCalendar($startDate: String!, $endDate: String!) {
    getMyCycleCalendar(startDate: $startDate, endDate: $endDate) {
      date
      is_period
      phase
      is_predicted
    }
  }
`;
export const LogPeriodDayDocument = gql`
  mutation LogPeriodDay($date: String!, $is_period: Boolean!) {
    logPeriodDay(date: $date, is_period: $is_period) {
      id
      date
      is_period
    }
  }
`;
export const GetMissedPeriodPredictionsDocument = gql`
  query GetMissedPeriodPredictions {
    getMissedPeriodPredictions {
      date
      days_ago
      is_continuation
    }
  }
`;
export const RespondToMissedPredictionDocument = gql`
  mutation RespondToMissedPrediction($date: String!, $response: String!) {
    respondToMissedPrediction(date: $date, response: $response)
  }
`;
export const GetIntimacySessionsByDateRangeDocument = gql`
  query GetIntimacySessionsByDateRange(
    $start_date: String!
    $end_date: String!
  ) {
    getIntimacySessionsByDateRange(
      start_date: $start_date
      end_date: $end_date
    ) {
      id
      date
      time
      duration_minutes
      husband_orgasm_count
      wife_orgasm_count
      initiator
      activities_husband
      activities_wife
      activities_shared
      substances {
        person
        type
        amount
        effectiveness
      }
      notes
      created_at
      updated_at
    }
  }
`;
export const LogIntimacySessionDocument = gql`
  mutation LogIntimacySession(
    $id: Int
    $date: String!
    $time: String
    $duration_minutes: Int
    $husband_orgasm_count: Int
    $wife_orgasm_count: Int
    $initiator: String
    $activities_husband: [String]
    $activities_wife: [String]
    $activities_shared: [String]
    $substances: [SubstanceInput]
    $notes: String
  ) {
    logIntimacySession(
      id: $id
      date: $date
      time: $time
      duration_minutes: $duration_minutes
      husband_orgasm_count: $husband_orgasm_count
      wife_orgasm_count: $wife_orgasm_count
      initiator: $initiator
      activities_husband: $activities_husband
      activities_wife: $activities_wife
      activities_shared: $activities_shared
      substances: $substances
      notes: $notes
    ) {
      id
      date
      time
      duration_minutes
      husband_orgasm_count
      wife_orgasm_count
      initiator
      activities_husband
      activities_wife
      activities_shared
      substances {
        person
        type
        amount
        effectiveness
      }
      notes
    }
  }
`;
export const DeleteIntimacySessionDocument = gql`
  mutation DeleteIntimacySession($id: Int!) {
    deleteIntimacySession(id: $id)
  }
`;
export const GetCustomIntimacyActivitiesDocument = gql`
  query GetCustomIntimacyActivities {
    getCustomIntimacyActivities
  }
`;
export const AddCustomIntimacyActivityDocument = gql`
  mutation AddCustomIntimacyActivity($activity: String!) {
    addCustomIntimacyActivity(activity: $activity) {
      id
      custom_intimacy_activities
    }
  }
`;
export const RemoveCustomIntimacyActivityDocument = gql`
  mutation RemoveCustomIntimacyActivity($activity: String!) {
    removeCustomIntimacyActivity(activity: $activity) {
      id
      custom_intimacy_activities
    }
  }
`;
export const SubmitActivityRequestDocument = gql`
  mutation SubmitActivityRequest(
    $activity_name: String!
    $description: String
  ) {
    submitActivityRequest(
      activity_name: $activity_name
      description: $description
    )
  }
`;
export const GetIntimacyStatsDocument = gql`
  query GetIntimacyStats {
    getIntimacyStats {
      total_sessions
      avg_sessions_per_week
      avg_days_between_sessions
      total_husband_orgasms
      total_wife_orgasms
      avg_husband_orgasms_per_session
      avg_wife_orgasms_per_session
      avg_duration_minutes
      days_since_last_intimacy
      days_since_husband_orgasm
      days_since_wife_orgasm
      days_since_husband_initiated
      days_since_wife_initiated
      mutual_orgasm_rate
      orgasm_gap
      orgasm_ratio_husband
      orgasm_ratio_wife
      orgasm_ratio_husband_recent
      orgasm_ratio_wife_recent
      activity_diversity
      sessions_with_zero_orgasms
      most_common_day_of_week
      time_between_sessions_trend
      current_streak
      median_duration_minutes
      new_activities_this_month
      longest_gap_days
      sessions_this_week
      activity_counts {
        activity
        count
        orgasm_correlation
      }
      activity_counts_husband {
        activity
        count
        orgasm_correlation
      }
      activity_counts_wife {
        activity
        count
        orgasm_correlation
      }
      initiator_counts {
        husband
        wife
        mutual
      }
      cycle_prediction {
        average_cycle_length
        average_period_length
      }
      substance_stats {
        total_sessions_with_substances
        usage_by_substance {
          substance
          count
          avg_dosage
          avg_effectiveness
          sessions_with_substance
          trend
        }
      }
    }
  }
`;
export const GetIntimacyActivitiesAdminDocument = gql`
  query GetIntimacyActivitiesAdmin {
    intimacyActivitiesAdmin {
      id
      name
      label
      category
      is_active
      is_shared
      user_id
      sort_order
      created_at
      canonical_activity_id
      link_status
      link_suggestion_score
      canonical_activity {
        id
        name
        label
      }
    }
  }
`;
export const GetIntimacyActivityUsageStatsDocument = gql`
  query GetIntimacyActivityUsageStats {
    getIntimacyActivityUsageStats {
      activity_name
      activity_label
      count
      distinct_users
    }
  }
`;
export const RescanActivityLinkSuggestionsDocument = gql`
  mutation RescanActivityLinkSuggestions {
    rescanActivityLinkSuggestions
  }
`;
export const ApproveActivityLinkDocument = gql`
  mutation ApproveActivityLink($id: Int!, $canonicalActivityId: Int) {
    approveActivityLink(id: $id, canonicalActivityId: $canonicalActivityId) {
      id
      canonical_activity_id
      link_status
      link_suggestion_score
    }
  }
`;
export const RejectActivityLinkDocument = gql`
  mutation RejectActivityLink($id: Int!) {
    rejectActivityLink(id: $id) {
      id
      canonical_activity_id
      link_status
      link_suggestion_score
    }
  }
`;
export const LinkActivityToCanonicalDocument = gql`
  mutation LinkActivityToCanonical($id: Int!, $canonicalActivityId: Int!) {
    linkActivityToCanonical(
      id: $id
      canonicalActivityId: $canonicalActivityId
    ) {
      id
      canonical_activity_id
      link_status
      link_suggestion_score
    }
  }
`;
export const UnlinkActivityDocument = gql`
  mutation UnlinkActivity($id: Int!) {
    unlinkActivity(id: $id) {
      id
      canonical_activity_id
      link_status
      link_suggestion_score
    }
  }
`;
export const CreateIntimacyActivityDocument = gql`
  mutation CreateIntimacyActivity(
    $name: String!
    $label: String!
    $category: String
    $is_shared: Boolean
    $user_id: Int
    $sort_order: Int
  ) {
    createIntimacyActivity(
      name: $name
      label: $label
      category: $category
      is_shared: $is_shared
      user_id: $user_id
      sort_order: $sort_order
    ) {
      id
      name
      label
      category
      is_active
      is_shared
      user_id
      sort_order
      created_at
    }
  }
`;
export const UpdateIntimacyActivityDocument = gql`
  mutation UpdateIntimacyActivity(
    $id: Int!
    $name: String
    $label: String
    $category: String
    $is_active: Boolean
    $is_shared: Boolean
    $user_id: Int
    $sort_order: Int
  ) {
    updateIntimacyActivity(
      id: $id
      name: $name
      label: $label
      category: $category
      is_active: $is_active
      is_shared: $is_shared
      user_id: $user_id
      sort_order: $sort_order
    ) {
      id
      name
      label
      category
      is_active
      is_shared
      user_id
      sort_order
      created_at
    }
  }
`;
export const DeleteIntimacyActivityDocument = gql`
  mutation DeleteIntimacyActivity($id: Int!) {
    deleteIntimacyActivity(id: $id)
  }
`;
export const GetMyActivitiesDocument = gql`
  query GetMyActivities(
    $limit: Int
    $offset: Int
    $unread_only: Boolean
    $activity_type: String
    $since: DateTime
  ) {
    getMyActivities(
      limit: $limit
      offset: $offset
      unread_only: $unread_only
      activity_type: $activity_type
      since: $since
    ) {
      ...PartnerActivityFields
    }
  }
  ${PartnerActivityFieldsFragmentDoc}
`;
export const GetUnreadActivityCountDocument = gql`
  query GetUnreadActivityCount($exclude_actor: String) {
    getUnreadActivityCount(exclude_actor: $exclude_actor)
  }
`;
export const GetPendingResponsesDocument = gql`
  query GetPendingResponses {
    getPendingResponses {
      ...PartnerActivityFields
    }
  }
  ${PartnerActivityFieldsFragmentDoc}
`;
export const CreateActivityDocument = gql`
  mutation CreateActivity(
    $activity_type: String!
    $actor: String!
    $title: String!
    $message: String
    $link: String
    $metadata: JSON
    $requires_response: Boolean
  ) {
    createActivity(
      activity_type: $activity_type
      actor: $actor
      title: $title
      message: $message
      link: $link
      metadata: $metadata
      requires_response: $requires_response
    ) {
      id
      created_at
    }
  }
`;
export const MarkActivitiesReadDocument = gql`
  mutation MarkActivitiesRead($activity_ids: [Int], $mark_all: Boolean) {
    markActivitiesRead(activity_ids: $activity_ids, mark_all: $mark_all)
  }
`;
export const RespondToActivityDocument = gql`
  mutation RespondToActivity(
    $activity_id: Int!
    $response_status: String!
    $response_note: String
  ) {
    respondToActivity(
      activity_id: $activity_id
      response_status: $response_status
      response_note: $response_note
    ) {
      ...PartnerActivityFields
    }
  }
  ${PartnerActivityFieldsFragmentDoc}
`;
export const SubscribePushDocument = gql`
  mutation SubscribePush(
    $endpoint: String!
    $p256dh: String!
    $auth: String!
    $user_agent: String
  ) {
    subscribePush(
      endpoint: $endpoint
      p256dh: $p256dh
      auth: $auth
      user_agent: $user_agent
    ) {
      id
      endpoint
    }
  }
`;
export const UnsubscribePushDocument = gql`
  mutation UnsubscribePush($endpoint: String!) {
    unsubscribePush(endpoint: $endpoint)
  }
`;
export const ScheduleReminderDocument = gql`
  mutation ScheduleReminder(
    $contact: String!
    $message: String!
    $link: String!
    $daysFromNow: Int
    $minutesFromNow: Int
  ) {
    scheduleReminder(
      contact: $contact
      message: $message
      link: $link
      daysFromNow: $daysFromNow
      minutesFromNow: $minutesFromNow
    ) {
      success
      message
      reminderId
    }
  }
`;
export const SetPushExcludedActorDocument = gql`
  mutation SetPushExcludedActor($excluded_actor: String!, $endpoint: String) {
    setPushExcludedActor(excluded_actor: $excluded_actor, endpoint: $endpoint)
  }
`;
export const GetScheduledSessionsDocument = gql`
  query GetScheduledSessions($upcoming_only: Boolean) {
    getScheduledSessions(upcoming_only: $upcoming_only) {
      ...ScheduledSessionFields
    }
  }
  ${ScheduledSessionFieldsFragmentDoc}
`;
export const GetPendingSchedulesDocument = gql`
  query GetPendingSchedules {
    getPendingSchedules {
      ...ScheduledSessionFields
    }
  }
  ${ScheduledSessionFieldsFragmentDoc}
`;
export const CreateScheduledSessionDocument = gql`
  mutation CreateScheduledSession(
    $scheduled_for: DateTime
    $title: String
    $message: String
    $created_by: String!
    $activity_type: String
    $is_immediate: Boolean
  ) {
    createScheduledSession(
      scheduled_for: $scheduled_for
      title: $title
      message: $message
      created_by: $created_by
      activity_type: $activity_type
      is_immediate: $is_immediate
    ) {
      ...ScheduledSessionFields
    }
  }
  ${ScheduledSessionFieldsFragmentDoc}
`;
export const RespondToScheduledSessionDocument = gql`
  mutation RespondToScheduledSession(
    $session_id: Int!
    $status: String!
    $response_note: String
  ) {
    respondToScheduledSession(
      session_id: $session_id
      status: $status
      response_note: $response_note
    ) {
      ...ScheduledSessionFields
    }
  }
  ${ScheduledSessionFieldsFragmentDoc}
`;
export const CancelScheduledSessionDocument = gql`
  mutation CancelScheduledSession($session_id: Int!, $reason: String) {
    cancelScheduledSession(session_id: $session_id, reason: $reason) {
      ...ScheduledSessionFields
    }
  }
  ${ScheduledSessionFieldsFragmentDoc}
`;
export const MarkSessionOutcomeDocument = gql`
  mutation MarkSessionOutcome(
    $session_id: Int!
    $outcome: String!
    $note: String
  ) {
    markSessionOutcome(
      session_id: $session_id
      outcome: $outcome
      note: $note
    ) {
      ...ScheduledSessionFields
    }
  }
  ${ScheduledSessionFieldsFragmentDoc}
`;
export const DeleteScheduledSessionDocument = gql`
  mutation DeleteScheduledSession($session_id: Int!) {
    deleteScheduledSession(session_id: $session_id)
  }
`;
export const GetMyPreferencesDocument = gql`
  query GetMyPreferences {
    getMyPreferences {
      ...UserPreferencesFields
    }
  }
  ${UserPreferencesFieldsFragmentDoc}
`;
export const UpdateCommunicationPreferencesDocument = gql`
  mutation UpdateCommunicationPreferences(
    $husband_email: String
    $wife_email: String
  ) {
    updateCommunicationPreferences(
      husband_email: $husband_email
      wife_email: $wife_email
    ) {
      ...UserPreferencesFields
    }
  }
  ${UserPreferencesFieldsFragmentDoc}
`;
export const UpdateIntimacyFrequencyPreferencesDocument = gql`
  mutation UpdateIntimacyFrequencyPreferences(
    $intimacy_frequency_mode: String
    $intimacy_frequency_days: Int
  ) {
    updateIntimacyFrequencyPreferences(
      intimacy_frequency_mode: $intimacy_frequency_mode
      intimacy_frequency_days: $intimacy_frequency_days
    ) {
      ...UserPreferencesFields
    }
  }
  ${UserPreferencesFieldsFragmentDoc}
`;
export const UpdateSubstanceTrackingPreferenceDocument = gql`
  mutation UpdateSubstanceTrackingPreference(
    $enable_substance_tracking: Boolean!
  ) {
    updateSubstanceTrackingPreference(
      enable_substance_tracking: $enable_substance_tracking
    ) {
      ...UserPreferencesFields
    }
  }
  ${UserPreferencesFieldsFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
  _variables
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {
    GetActivityReactions(
      variables?: GetActivityReactionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetActivityReactionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetActivityReactionsQuery>({
            document: GetActivityReactionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetActivityReactions",
        "query",
        variables
      );
    },
    AddReaction(
      variables: AddReactionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<AddReactionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AddReactionMutation>({
            document: AddReactionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "AddReaction",
        "mutation",
        variables
      );
    },
    RemoveReaction(
      variables: RemoveReactionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RemoveReactionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveReactionMutation>({
            document: RemoveReactionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RemoveReaction",
        "mutation",
        variables
      );
    },
    SubmitBugReport(
      variables: SubmitBugReportMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<SubmitBugReportMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubmitBugReportMutation>({
            document: SubmitBugReportDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SubmitBugReport",
        "mutation",
        variables
      );
    },
    SubmitIdea(
      variables: SubmitIdeaMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<SubmitIdeaMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubmitIdeaMutation>({
            document: SubmitIdeaDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SubmitIdea",
        "mutation",
        variables
      );
    },
    GetAnalyticsSummary(
      variables?: GetAnalyticsSummaryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetAnalyticsSummaryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAnalyticsSummaryQuery>({
            document: GetAnalyticsSummaryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetAnalyticsSummary",
        "query",
        variables
      );
    },
    GetFeatureUsageByPeriod(
      variables: GetFeatureUsageByPeriodQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetFeatureUsageByPeriodQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeatureUsageByPeriodQuery>({
            document: GetFeatureUsageByPeriodDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetFeatureUsageByPeriod",
        "query",
        variables
      );
    },
    GetDailyUsageChart(
      variables?: GetDailyUsageChartQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetDailyUsageChartQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDailyUsageChartQuery>({
            document: GetDailyUsageChartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetDailyUsageChart",
        "query",
        variables
      );
    },
    TrackFeatureUsage(
      variables: TrackFeatureUsageMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<TrackFeatureUsageMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TrackFeatureUsageMutation>({
            document: TrackFeatureUsageDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "TrackFeatureUsage",
        "mutation",
        variables
      );
    },
    NextConversationStarters(
      variables?: NextConversationStartersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<NextConversationStartersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<NextConversationStartersQuery>({
            document: NextConversationStartersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "NextConversationStarters",
        "query",
        variables
      );
    },
    RespondToConversationStarter(
      variables?: RespondToConversationStarterMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RespondToConversationStarterMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RespondToConversationStarterMutation>({
            document: RespondToConversationStarterDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RespondToConversationStarter",
        "mutation",
        variables
      );
    },
    ConversationStarterCategoryPrefs(
      variables?: ConversationStarterCategoryPrefsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ConversationStarterCategoryPrefsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConversationStarterCategoryPrefsQuery>({
            document: ConversationStarterCategoryPrefsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ConversationStarterCategoryPrefs",
        "query",
        variables
      );
    },
    ConversationCategoryRemaining(
      variables?: ConversationCategoryRemainingQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ConversationCategoryRemainingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConversationCategoryRemainingQuery>({
            document: ConversationCategoryRemainingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ConversationCategoryRemaining",
        "query",
        variables
      );
    },
    AllConversationStarterCards(
      variables?: AllConversationStarterCardsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<AllConversationStarterCardsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AllConversationStarterCardsQuery>({
            document: AllConversationStarterCardsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "AllConversationStarterCards",
        "query",
        variables
      );
    },
    CreateConversationStarterCard(
      variables?: CreateConversationStarterCardMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<CreateConversationStarterCardMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateConversationStarterCardMutation>({
            document: CreateConversationStarterCardDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CreateConversationStarterCard",
        "mutation",
        variables
      );
    },
    UpdateConversationStarterCard(
      variables?: UpdateConversationStarterCardMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UpdateConversationStarterCardMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateConversationStarterCardMutation>({
            document: UpdateConversationStarterCardDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateConversationStarterCard",
        "mutation",
        variables
      );
    },
    DeleteConversationStarterCard(
      variables?: DeleteConversationStarterCardMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<DeleteConversationStarterCardMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteConversationStarterCardMutation>({
            document: DeleteConversationStarterCardDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "DeleteConversationStarterCard",
        "mutation",
        variables
      );
    },
    SetConversationStarterCategoryPrefs(
      variables?: SetConversationStarterCategoryPrefsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<SetConversationStarterCategoryPrefsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SetConversationStarterCategoryPrefsMutation>({
            document: SetConversationStarterCategoryPrefsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SetConversationStarterCategoryPrefs",
        "mutation",
        variables
      );
    },
    ConversationStarterStats(
      variables?: ConversationStarterStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ConversationStarterStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConversationStarterStatsQuery>({
            document: ConversationStarterStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ConversationStarterStats",
        "query",
        variables
      );
    },
    GetCoupleEmails(
      variables?: GetCoupleEmailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetCoupleEmailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCoupleEmailsQuery>({
            document: GetCoupleEmailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetCoupleEmails",
        "query",
        variables
      );
    },
    GetIntimacyActivities(
      variables?: GetIntimacyActivitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetIntimacyActivitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetIntimacyActivitiesQuery>({
            document: GetIntimacyActivitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetIntimacyActivities",
        "query",
        variables
      );
    },
    GetMyCustomSubstances(
      variables?: GetMyCustomSubstancesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetMyCustomSubstancesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMyCustomSubstancesQuery>({
            document: GetMyCustomSubstancesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetMyCustomSubstances",
        "query",
        variables
      );
    },
    GetMyCyclePrediction(
      variables?: GetMyCyclePredictionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetMyCyclePredictionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMyCyclePredictionQuery>({
            document: GetMyCyclePredictionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetMyCyclePrediction",
        "query",
        variables
      );
    },
    GetMyCycleCalendar(
      variables: GetMyCycleCalendarQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetMyCycleCalendarQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMyCycleCalendarQuery>({
            document: GetMyCycleCalendarDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetMyCycleCalendar",
        "query",
        variables
      );
    },
    LogPeriodDay(
      variables: LogPeriodDayMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<LogPeriodDayMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LogPeriodDayMutation>({
            document: LogPeriodDayDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "LogPeriodDay",
        "mutation",
        variables
      );
    },
    GetMissedPeriodPredictions(
      variables?: GetMissedPeriodPredictionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetMissedPeriodPredictionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMissedPeriodPredictionsQuery>({
            document: GetMissedPeriodPredictionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetMissedPeriodPredictions",
        "query",
        variables
      );
    },
    RespondToMissedPrediction(
      variables: RespondToMissedPredictionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RespondToMissedPredictionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RespondToMissedPredictionMutation>({
            document: RespondToMissedPredictionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RespondToMissedPrediction",
        "mutation",
        variables
      );
    },
    GetIntimacySessionsByDateRange(
      variables: GetIntimacySessionsByDateRangeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetIntimacySessionsByDateRangeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetIntimacySessionsByDateRangeQuery>({
            document: GetIntimacySessionsByDateRangeDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetIntimacySessionsByDateRange",
        "query",
        variables
      );
    },
    LogIntimacySession(
      variables: LogIntimacySessionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<LogIntimacySessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LogIntimacySessionMutation>({
            document: LogIntimacySessionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "LogIntimacySession",
        "mutation",
        variables
      );
    },
    DeleteIntimacySession(
      variables: DeleteIntimacySessionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<DeleteIntimacySessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteIntimacySessionMutation>({
            document: DeleteIntimacySessionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "DeleteIntimacySession",
        "mutation",
        variables
      );
    },
    GetCustomIntimacyActivities(
      variables?: GetCustomIntimacyActivitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetCustomIntimacyActivitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCustomIntimacyActivitiesQuery>({
            document: GetCustomIntimacyActivitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetCustomIntimacyActivities",
        "query",
        variables
      );
    },
    AddCustomIntimacyActivity(
      variables: AddCustomIntimacyActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<AddCustomIntimacyActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AddCustomIntimacyActivityMutation>({
            document: AddCustomIntimacyActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "AddCustomIntimacyActivity",
        "mutation",
        variables
      );
    },
    RemoveCustomIntimacyActivity(
      variables: RemoveCustomIntimacyActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RemoveCustomIntimacyActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveCustomIntimacyActivityMutation>({
            document: RemoveCustomIntimacyActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RemoveCustomIntimacyActivity",
        "mutation",
        variables
      );
    },
    SubmitActivityRequest(
      variables: SubmitActivityRequestMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<SubmitActivityRequestMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubmitActivityRequestMutation>({
            document: SubmitActivityRequestDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SubmitActivityRequest",
        "mutation",
        variables
      );
    },
    GetIntimacyStats(
      variables?: GetIntimacyStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetIntimacyStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetIntimacyStatsQuery>({
            document: GetIntimacyStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetIntimacyStats",
        "query",
        variables
      );
    },
    GetIntimacyActivitiesAdmin(
      variables?: GetIntimacyActivitiesAdminQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetIntimacyActivitiesAdminQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetIntimacyActivitiesAdminQuery>({
            document: GetIntimacyActivitiesAdminDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetIntimacyActivitiesAdmin",
        "query",
        variables
      );
    },
    GetIntimacyActivityUsageStats(
      variables?: GetIntimacyActivityUsageStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetIntimacyActivityUsageStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetIntimacyActivityUsageStatsQuery>({
            document: GetIntimacyActivityUsageStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetIntimacyActivityUsageStats",
        "query",
        variables
      );
    },
    RescanActivityLinkSuggestions(
      variables?: RescanActivityLinkSuggestionsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RescanActivityLinkSuggestionsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RescanActivityLinkSuggestionsMutation>({
            document: RescanActivityLinkSuggestionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RescanActivityLinkSuggestions",
        "mutation",
        variables
      );
    },
    ApproveActivityLink(
      variables: ApproveActivityLinkMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ApproveActivityLinkMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApproveActivityLinkMutation>({
            document: ApproveActivityLinkDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ApproveActivityLink",
        "mutation",
        variables
      );
    },
    RejectActivityLink(
      variables: RejectActivityLinkMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RejectActivityLinkMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RejectActivityLinkMutation>({
            document: RejectActivityLinkDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RejectActivityLink",
        "mutation",
        variables
      );
    },
    LinkActivityToCanonical(
      variables: LinkActivityToCanonicalMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<LinkActivityToCanonicalMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LinkActivityToCanonicalMutation>({
            document: LinkActivityToCanonicalDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "LinkActivityToCanonical",
        "mutation",
        variables
      );
    },
    UnlinkActivity(
      variables: UnlinkActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UnlinkActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UnlinkActivityMutation>({
            document: UnlinkActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UnlinkActivity",
        "mutation",
        variables
      );
    },
    CreateIntimacyActivity(
      variables: CreateIntimacyActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<CreateIntimacyActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateIntimacyActivityMutation>({
            document: CreateIntimacyActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CreateIntimacyActivity",
        "mutation",
        variables
      );
    },
    UpdateIntimacyActivity(
      variables: UpdateIntimacyActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UpdateIntimacyActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateIntimacyActivityMutation>({
            document: UpdateIntimacyActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateIntimacyActivity",
        "mutation",
        variables
      );
    },
    DeleteIntimacyActivity(
      variables: DeleteIntimacyActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<DeleteIntimacyActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteIntimacyActivityMutation>({
            document: DeleteIntimacyActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "DeleteIntimacyActivity",
        "mutation",
        variables
      );
    },
    GetMyActivities(
      variables?: GetMyActivitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetMyActivitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMyActivitiesQuery>({
            document: GetMyActivitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetMyActivities",
        "query",
        variables
      );
    },
    GetUnreadActivityCount(
      variables?: GetUnreadActivityCountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetUnreadActivityCountQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetUnreadActivityCountQuery>({
            document: GetUnreadActivityCountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetUnreadActivityCount",
        "query",
        variables
      );
    },
    GetPendingResponses(
      variables?: GetPendingResponsesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetPendingResponsesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPendingResponsesQuery>({
            document: GetPendingResponsesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetPendingResponses",
        "query",
        variables
      );
    },
    CreateActivity(
      variables: CreateActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<CreateActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateActivityMutation>({
            document: CreateActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CreateActivity",
        "mutation",
        variables
      );
    },
    MarkActivitiesRead(
      variables?: MarkActivitiesReadMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<MarkActivitiesReadMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MarkActivitiesReadMutation>({
            document: MarkActivitiesReadDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "MarkActivitiesRead",
        "mutation",
        variables
      );
    },
    RespondToActivity(
      variables: RespondToActivityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RespondToActivityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RespondToActivityMutation>({
            document: RespondToActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RespondToActivity",
        "mutation",
        variables
      );
    },
    SubscribePush(
      variables: SubscribePushMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<SubscribePushMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubscribePushMutation>({
            document: SubscribePushDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SubscribePush",
        "mutation",
        variables
      );
    },
    UnsubscribePush(
      variables: UnsubscribePushMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UnsubscribePushMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UnsubscribePushMutation>({
            document: UnsubscribePushDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UnsubscribePush",
        "mutation",
        variables
      );
    },
    ScheduleReminder(
      variables: ScheduleReminderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ScheduleReminderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ScheduleReminderMutation>({
            document: ScheduleReminderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ScheduleReminder",
        "mutation",
        variables
      );
    },
    SetPushExcludedActor(
      variables: SetPushExcludedActorMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<SetPushExcludedActorMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SetPushExcludedActorMutation>({
            document: SetPushExcludedActorDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SetPushExcludedActor",
        "mutation",
        variables
      );
    },
    GetScheduledSessions(
      variables?: GetScheduledSessionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetScheduledSessionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetScheduledSessionsQuery>({
            document: GetScheduledSessionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetScheduledSessions",
        "query",
        variables
      );
    },
    GetPendingSchedules(
      variables?: GetPendingSchedulesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetPendingSchedulesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPendingSchedulesQuery>({
            document: GetPendingSchedulesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetPendingSchedules",
        "query",
        variables
      );
    },
    CreateScheduledSession(
      variables: CreateScheduledSessionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<CreateScheduledSessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateScheduledSessionMutation>({
            document: CreateScheduledSessionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CreateScheduledSession",
        "mutation",
        variables
      );
    },
    RespondToScheduledSession(
      variables: RespondToScheduledSessionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<RespondToScheduledSessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RespondToScheduledSessionMutation>({
            document: RespondToScheduledSessionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RespondToScheduledSession",
        "mutation",
        variables
      );
    },
    CancelScheduledSession(
      variables: CancelScheduledSessionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<CancelScheduledSessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CancelScheduledSessionMutation>({
            document: CancelScheduledSessionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CancelScheduledSession",
        "mutation",
        variables
      );
    },
    MarkSessionOutcome(
      variables: MarkSessionOutcomeMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<MarkSessionOutcomeMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MarkSessionOutcomeMutation>({
            document: MarkSessionOutcomeDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "MarkSessionOutcome",
        "mutation",
        variables
      );
    },
    DeleteScheduledSession(
      variables: DeleteScheduledSessionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<DeleteScheduledSessionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteScheduledSessionMutation>({
            document: DeleteScheduledSessionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "DeleteScheduledSession",
        "mutation",
        variables
      );
    },
    GetMyPreferences(
      variables?: GetMyPreferencesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<GetMyPreferencesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMyPreferencesQuery>({
            document: GetMyPreferencesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetMyPreferences",
        "query",
        variables
      );
    },
    UpdateCommunicationPreferences(
      variables?: UpdateCommunicationPreferencesMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UpdateCommunicationPreferencesMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateCommunicationPreferencesMutation>({
            document: UpdateCommunicationPreferencesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateCommunicationPreferences",
        "mutation",
        variables
      );
    },
    UpdateIntimacyFrequencyPreferences(
      variables?: UpdateIntimacyFrequencyPreferencesMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UpdateIntimacyFrequencyPreferencesMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateIntimacyFrequencyPreferencesMutation>({
            document: UpdateIntimacyFrequencyPreferencesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateIntimacyFrequencyPreferences",
        "mutation",
        variables
      );
    },
    UpdateSubstanceTrackingPreference(
      variables: UpdateSubstanceTrackingPreferenceMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<UpdateSubstanceTrackingPreferenceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateSubstanceTrackingPreferenceMutation>({
            document: UpdateSubstanceTrackingPreferenceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateSubstanceTrackingPreference",
        "mutation",
        variables
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
